import { Tooltip as BaseTooltip } from "@base-ui/react/tooltip";
import type { ReactElement, ReactNode } from "react";

// Labels for icon-only buttons. Wrap the app once in TooltipProvider so neighbours open instantly.
export const TooltipProvider = BaseTooltip.Provider;

export interface TooltipProps {
  readonly label: ReactNode;
  readonly children: ReactElement;
  readonly side?: "top" | "bottom" | "left" | "right";
}

export const Tooltip = ({ label, children, side = "bottom" }: TooltipProps) => (
  <BaseTooltip.Root>
    <BaseTooltip.Trigger render={children} />
    <BaseTooltip.Portal>
      <BaseTooltip.Positioner side={side} sideOffset={6} className="z-50">
        <BaseTooltip.Popup className="rounded-sm bg-control px-2 py-1 text-[12px] leading-4 tracking-normal text-text shadow-tile transition-opacity duration-100 data-ending-style:opacity-0 data-starting-style:opacity-0">
          {label}
        </BaseTooltip.Popup>
      </BaseTooltip.Positioner>
    </BaseTooltip.Portal>
  </BaseTooltip.Root>
);
